
import * as H from "history";

export interface ILocationHistory {
    length: () => number;
    history: () => Array<H.Location>;
    findFirstPathPrefix: (pathPrefix: Array<string>) => number;
    findPathPrefix: (pathPrefix: string) => number;
}

export interface ILocationHistoryPrivate extends ILocationHistory {
    _history: Array<H.Location>;
    _controller: H.History;
}


type HISTORY_ACTIONS = 'PUSH' | 'POP' | 'REPLACE';

function LocationHistory(history: H.History<unknown>): ILocationHistory {
    
    const val: ILocationHistoryPrivate = {
        length: function(this: ILocationHistoryPrivate) { return this._history.length; },
        _history: [],
        _controller: history,
        findFirstPathPrefix: function(this: ILocationHistoryPrivate, pathPrefixes: Array<string>) {
            for ( let idx=0; idx<pathPrefixes.length; idx++ ) {
                const path = pathPrefixes[idx];
                const idxSearch = this.findPathPrefix(path);
                if ( idxSearch >= 0 ) { return idxSearch; }
            }
            return -1;
        },
        findPathPrefix: function(this: ILocationHistoryPrivate, pathPrefix: string) {
            for ( let idx=0; idx<this._history.length; idx++ ) {
                const location = this._history[idx];
                if ( location.pathname.startsWith(pathPrefix) ) {
                    return idx;
                }
            }
            return -1;
        },
        history: function(this: ILocationHistoryPrivate) {
            return this._history;
        },
    }

    history.listen(function(location: H.Location, action: HISTORY_ACTIONS) {
        switch (action) {
            case 'PUSH':
                val._history.push(location);
                break;

            case 'POP':
                val._history.splice(-1, 1);
                break;

            case 'REPLACE':
                val._history.splice(-1, 1, location);
                break;
        }
    });

    return val;
}


export default LocationHistory
